import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Process from './pages/Process';
import { loadFonts } from './utils/fontLoader';
import AdminPortal, { ADMIN_ROUTE } from './pages/AdminPortal';

const App: React.FC = () => {
  useEffect(() => {
    loadFonts();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/process" element={<Process />} />
        <Route path={ADMIN_ROUTE} element={<AdminPortal />} />
      </Routes>
    </Router>
  );
};

export default App;